import store from 'store';

export const localGet = (key, fallbackValue = null) => {
  const value = store.get(key, fallbackValue);

  if (fallbackValue !== null && typeof value !== typeof fallbackValue) {
    console.error('localGet type mismatch', key, typeof value, typeof fallbackValue);
  }

  return value;
};

export const localSet = (key, item) => store.set(key, item);



// WEBPACK FOOTER //
// ./src/utils/localStorage.js